'use strict';

module.exports = {
    input: require('../directives/input'),
    select: require('../directives/select')
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/mixins/directives.js